import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {USPsSection_ArticleUSP_MOV} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {useTranslation} from '@aboutyou/i18n';
import {COLORS, MOV} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {USPsViewProps} from './USPsView';
import {Badge, UspItem} from './UspItem';

interface UspMovProps {
  selectedSize: USPsViewProps['selectedSize'];
  movSection: USPsSection_ArticleUSP_MOV;
}

export const UspMov: React.FC<UspMovProps> = ({selectedSize, movSection}) => {
  const {t} = useTranslation();
  const {isActive: isMovFeatureFlagActive} = useIsFeatureActive('adp_mov');

  const selectedSizeFreeDeliverySection =
    selectedSize?.availability?.$case === 'inStock'
      ? selectedSize?.availability.inStock.freeDeliveryProgressSection
      : undefined;

  const freeDeliverySection =
    selectedSizeFreeDeliverySection ?? movSection.freeDeliveryProgressSection;

  const isMOVReached = Boolean(
    freeDeliverySection?.progress === 0 || freeDeliverySection?.progress === 1,
  );

  if (
    !isMovFeatureFlagActive ||
    !freeDeliverySection ||
    !movSection.freeDeliveryProgressSection
  ) {
    return null;
  }

  return (
    <UspItem
      href={movSection.targetUrl?.url}
      image={movSection.image}
      text={freeDeliverySection.freeDeliveryLabel}
      badge={
        isMOVReached && (
          <Badge data-testid="uspMovFreeBadge" $backgroundColor={COLORS.Green3}>
            {t('Free')}
          </Badge>
        )
      }
    >
      {!isMOVReached && (
        <StyledMOV
          data-testid="uspMov"
          progress={freeDeliverySection.progress}
          label={freeDeliverySection.amountUntilFreeShipping}
        />
      )}
    </UspItem>
  );
};

const StyledMOV = styled(MOV)`
  background-color: ${COLORS.Grey4};
  padding: 8px 12px;
  border-radius: 3px;
`;
